<template>
    <div>
        <!-- Botões de Ação -->
        <div
            class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 space-y-3 md:space-y-0 md:space-x-3">
            <!-- Botão Adicionar Kit -->
            <button @click="$emit('show-add-kit-modal')"
                class="w-full md:w-auto bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg">
                <PlusCircle class="w-5 h-5" />
                <span>Adicionar Kit</span>
            </button>

            <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                <!-- Botão para Abrir Modal de Filtros -->
                <button @click="showFilterModal = true"
                    class="w-full md:w-auto bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg">
                    <Filter class="w-5 h-5" />
                    <span>Filtrar</span>
                </button>
                <button @click="clearFilters"
                    class="w-full md:w-auto bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 font-medium shadow-lg whitespace-nowrap">
                    <Icon :iconNode="broom" class="w-5 h-5" />
                    <span class="truncate">Limpar Filtros</span>
                </button>
            </div>
        </div>

        <!-- Listener removido: o modal de adicionar kit é controlado pelo componente pai -->
    </div>

    <!-- Tabela de Kits (Desktop) -->
    <div class="hidden md:block overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow">
        <table class="min-w-full table-fixed divide-y divide-gray-200 dark:divide-gray-700">
            <thead class="bg-blue-500 dark:bg-blue-600 text-white dark:text-gray-300 text-xs uppercase tracking-wide">
                <tr>
                    <th v-for="header in headers" :key="header.key"
                        class="py-4 px-6 text-left cursor-pointer select-none" @click="handleSort(header.key)"
                        :class="{ 'text-blue-200': sortColumn === header.key }">
                        <span>{{ header.label }}</span>
                        <span v-if="sortColumn === header.key">
                            <span v-if="sortDirection === 'asc'">⭡</span>
                            <span v-else>⭣</span>
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                <tr v-for="kit in kitsPaginados" :key="kit.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                    <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
                        {{ kit.kit_code }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                        <div class="flex items-center gap-2">
                            <span class="inline-block bg-blue-200 dark:bg-blue-700 text-blue-800 dark:text-blue-200 px-2 py-1 rounded">
                                {{ kit.equipamentos[0]?.serial_number || '-' }}
                            </span>
                            <button
                                v-if="kit.equipamentos.length > 1"
                                @click="openItensKitModal(kit)"
                                class="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                            >
                                Ver itens ({{ kit.equipamentos.length }})
                            </button>
                        </div>
</td>



                    <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400 text-nowrap">
                        <span :class="getAvailabilityClass(kit.status)">{{ kit.status }}</span>
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                        {{ kit.unidade || '-' }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                        {{ kit.setor || "Geral" }}
                    </td>
                    <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                        {{ kit.responsavel_interno?.nome || "-" }}
                    </td>
                    <td class="py-4 px-6 text-sm font-medium">
                        <button @click="$emit('ver-detalhes-kit', kit.id)"
                            class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 mr-3">
                            <EyeIcon class="h-5 w-5" />
                        </button>
                        <button @click="$emit('delete-kit', kit)"
                            class="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-400">
                            <Trash2 class="w-5 h-5" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Paginação Desktop -->
    <div class="hidden md:flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
        <div class="flex items-center gap-2 justify-center">
            <button @click="currentPage--" :disabled="currentPage === 1"
                class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Anterior</button>
            <span class="text-sm text-gray-700 dark:text-gray-200">Página {{ currentPage }} de {{ totalPages }}</span>
            <button @click="currentPage++" :disabled="currentPage === totalPages"
                class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Próxima</button>
        </div>
        <div class="flex items-center gap-2 justify-center">
            <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
            <select id="page-size" v-model.number="pageSize" @change="handlePageSizeChange"
                class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
            </select>
            <span v-if="totalCount !== null" class="text-xs text-gray-500 dark:text-gray-400">Total: {{ totalCount
                }}</span>
        </div>
    </div>

    <!-- Modal de Filtros -->
    <ModalTemplate v-if="showFilterModal" @close="showFilterModal = false">
        <template #header>Filtrar Kits</template>
        <template #body>
            <div class="space-y-4">
                <!-- Filtro por código do kit ou item -->
                <div>
                    <label for="filterKitCode" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Código do kit ou Serial do item
                    </label>
                    <input id="filterKitCode" v-model="localFilters.kit_code" type="text"
                        placeholder="Filtrar por código do kit ou serial de um item"
                        class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                </div>
                <div>
                    <label for="filterItemName" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Nome do item
                    </label>
                    <input id="filterItemName" v-model="localFilters.item_name" type="text"
                        placeholder="Filtrar por nome do item"
                        class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                </div>

                <!-- Filtro por Status -->
                <div>
                    <label for="filterStatus" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Status
                    </label>
                    <select id="filterStatus" v-model="localFilters.status"
                        class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                        <option value="">Todos os status</option>
                        <option value="Disponível">Disponível</option>
                        <option value="Indisponível">Indisponível</option>
                        <option value="Em uso">Em uso</option>
                        <option value="Em estoque">Em Estoque</option>
                    </select>
                </div>

                <!-- Filtro por Unidade -->
                <div>
                    <label for="filterUnidade" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Unidade
                    </label>
                    <select id="filterUnidade" v-model="localFilters.unidade"
                        class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                        <option value="">Todas as unidades</option>
                        <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">
                            {{ unidade.nome }}
                        </option>
                    </select>
                </div>

                <!-- Filtro por Setor -->
                <div>
                    <label for="filterSetor" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Setor
                    </label>
                    <select id="filterSetor" v-model="localFilters.setor" :disabled="!localFilters.unidade"
                        class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                        <option v-if="!localFilters.unidade" value="" selected>Selecione uma unidade primeiro</option>
                        <template v-else>
                            <option value="">Todos os setores</option>
                            <option
                                v-for="setor in setores.filter(s => s.unidade && s.unidade.id == localFilters.unidade)"
                                :key="setor.id" :value="setor.id">
                                {{ setor.nome }}<span v-if="setor.unidade"> - {{ setor.unidade.nome }}</span>
                            </option>
                        </template>
                    </select>
                </div>
<!-- Filtro por Responsável -->
<div>
  <label for="filterResponsavel" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
    Responsável
  </label>
  <select 
    id="filterResponsavel" 
    v-model="localFilters.responsavel_interno"
    class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
  >
    <option value="">Todos os Responsáveis</option>
    <option 
      v-for="responsible in responsibles" 
      :key="responsible.id" 
      :value="responsible.id"
    >
      {{ responsible.nome }}
    </option>
  </select>
</div>

            </div>

            <!-- Botões do Modal -->
            <div class="flex justify-end mt-6 space-x-4">
                <button @click="showFilterModal = false"
                    class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300">
                    Cancelar
                </button>
                <button @click="applyLocalFilters"
                    class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700">
                    Aplicar Filtros
                </button>
            </div>
        </template>
    </ModalTemplate>

    <!-- Cards de Kits (Mobile) -->
    <div class="block md:hidden space-y-4">
        <div v-for="kit in kitsPaginados" :key="kit.id" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
            <!-- ID -->
            <div class="flex items-center space-x-2">
                <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">ID:</span>
                <span class="text-sm text-gray-500 dark:text-gray-400">{{ kit.kit_code }}</span>
            </div>
            <!-- Itens -->
            <div class="flex items-center space-x-2">
                <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Itens:</span>
                <span class="text-sm text-gray-500 dark:text-gray-400">
                    {{ kit.equipamentos[0]?.serial_number || '-' }}
                </span>
                <button
                    v-if="kit.equipamentos.length > 1"
                    @click="openItensKitModal(kit)"
                    class="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                >
                    Ver itens ({{ kit.equipamentos.length }})
                </button>
            </div>
            <!-- Status -->
            <div class="flex items-center space-x-2">
                <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Status:</span>
                <span :class="getAvailabilityClass(kit.status)" class="text-sm">
                    {{ kit.status }}
                </span>
            </div>
            <!-- Unidade -->
            <div class="flex items-center space-x-2">
                <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Unidade:</span>
                <span class="text-sm text-gray-500 dark:text-gray-400">{{ kit.unidade || '-' }}</span>
            </div>
            <!-- Setor -->
            <div class="flex items-center space-x-2">
                <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Setor:</span>
                <span class="text-sm text-gray-500 dark:text-gray-400">{{ kit.setor || "Geral" }}</span>
            </div>
            <!-- Botões de Ação -->
            <div class="flex justify-end space-x-2 mt-2">
                <button @click="$emit('ver-detalhes-kit', kit.id)"
                    class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">
                    <EyeIcon class="h-5 w-5" />
                </button>
                <button @click="$emit('delete-kit', kit)"
                    class="text-red-600 hover:text-red-900 dark:text-red-500 dark:hover:text-red-400">
                    <Trash2 class="w-5 h-5" />
                </button>
            </div>
        </div>
    </div>
    <!-- Paginação Mobile -->
    <div class="flex md:hidden flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
        <div class="flex items-center gap-2 justify-center">
            <button @click="currentPage--" :disabled="currentPage === 1"
                class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Anterior</button>
            <span class="text-sm text-gray-700 dark:text-gray-200">Página {{ currentPage }} de {{ totalPages }}</span>
            <button @click="currentPage++" :disabled="currentPage === totalPages"
                class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Próxima</button>
        </div>
        <div class="flex items-center gap-2 justify-center">
            <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
            <select id="page-size" v-model.number="pageSize" @change="handlePageSizeChange"
                class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
            </select>
            <span v-if="totalCount !== null" class="text-xs text-gray-500 dark:text-gray-400">Total: {{ totalCount
                }}</span>
        </div>
    </div>
    <ModalTemplate v-if="isItensKitModalOpen" @close="closeItensKitModal">
        <template #header>Itens do kit {{ selectedKitCode }}</template>
        <template #body>
            <div class="max-h-64 overflow-y-auto space-y-2">
                <div
                    v-for="item in selectedKitItems"
                    :key="item.id"
                    class="border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2"
                >
                    <div class="text-sm font-medium text-gray-900 dark:text-white">{{ item.nome_item || item.modelo_nome || '-' }}</div>
                    <div class="text-xs text-gray-600 dark:text-gray-300">Serial: {{ item.serial_number || '-' }}</div>
                    <div class="text-xs text-gray-600 dark:text-gray-300">Tipo: {{ item.tipo || '-' }}</div>
                </div>
            </div>
            <div class="flex justify-end mt-4">
                <button
                    @click="closeItensKitModal"
                    class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                    Fechar
                </button>
            </div>
        </template>
    </ModalTemplate>

</template>

<script setup>
import { ref, onMounted, watch, defineEmits } from 'vue';
import { Trash2, PlusCircle, EyeIcon, Filter, Icon } from 'lucide-vue-next';
import { broom } from '@lucide/lab';
import { useKitsStore } from '@/stores/assets/KitsStore';
import { storeToRefs } from 'pinia';
import ModalTemplate from '@/views/templates/ModalTemplate.vue';
import apiClient from '@/services/authService';

const store = useKitsStore();
// Usando storeToRefs para manter a reatividade das propriedades da store
const { filters } = storeToRefs(store);

const emit = defineEmits([
    'show-add-kit-modal',
    'ver-detalhes-kit',
    'delete-kit',
    'apply-filters'
]);

const showFilterModal = ref(false);
const isItensKitModalOpen = ref(false);
const selectedKitItems = ref([]);
const selectedKitCode = ref('');

// Criando uma cópia reativa dos filtros da store
const localFilters = ref({ ...filters.value });

// Flag para evitar loops infinitos
let isUpdatingFromStore = false;

// Observar mudanças nos filtros da store para manter localFilters atualizado
// Apenas quando a mudança não vier de localFilters
watch(filters, (newFilters) => {
    if (!isUpdatingFromStore) {
        localFilters.value = { ...newFilters };
    }
}, { deep: true });

// Recebe evento do pai para atualizar lista e inicializa
onMounted(() => {
    if (typeof window !== 'undefined') {
        window.addEventListener('kit-adicionado', carregarKits);
    }
    localFilters.value = { ...filters.value };
    // carregarKits será chamado pelo watcher com immediate: true
});

// Aplicar filtros
const applyLocalFilters = () => {
    isUpdatingFromStore = true;
    store.setFilters(localFilters.value);
    isUpdatingFromStore = false;
    showFilterModal.value = false;
    emit('apply-filters', { ...localFilters.value });
    currentPage.value = 1;
    // carregarKits será chamado pelo watcher de filters
};

// Limpar filtros
function clearFilters() {
    localFilters.value = { status: '', unidade: '', kit_code: '', item_name: '', setor: '', responsavel_interno: ''};
    isUpdatingFromStore = true;
    store.setFilters(localFilters.value);
    isUpdatingFromStore = false;
    currentPage.value = 1;
    // carregarKits será chamado pelo watcher de filters
    emit('apply-filters', { ...localFilters.value });       
}

// Nova fonte de verdade: kitsPaginados
const kitsPaginados = ref([]);
const totalPages = ref(1);
const currentPage = ref(1);
const pageSize = ref(10);
const totalCount = ref(null);
const responsibles = ref([]);
const unidades = ref([]);
const setores = ref([]);

// Cabeçalhos e ordenação
const headers = [
    { key: 'id', label: 'ID' },
    { key: 'itens', label: 'Itens' },
    { key: 'status', label: 'Status' },
    { key: 'unidade__nome', label: 'Unidade' },
    { key: 'setor__nome', label: 'Setor' },
    { key: 'responsavel_interno', label: 'Responsável Interno' },
    { key: 'acoes', label: 'Ações' },
];
const sortColumn = ref('id');
const sortDirection = ref('desc');

function handleSort(column) {
    if (column === 'acoes' || column === 'itens' || column === 'responsavel_interno') return;
    if (sortColumn.value === column) {
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
    } else {
        sortColumn.value = column;
        sortDirection.value = 'asc';
    }
    currentPage.value = 1;
    carregarKits();
}

const fetchSetores = async () => {
    try {
        const response = await apiClient.get('/api/v1/enterprises/sectors/');
        setores.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar setores:", error);
    }
};

const fetchUnidades = async () => {
    try {

        const response = await apiClient.get('/api/v1/enterprises/');
        unidades.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar unidades:", error);
    }
};

const fetchResponsibles = async () => {
    try {

        const response = await apiClient.get('/api/v1/kits/responsibles/');
        responsibles.value = response.data;
    } catch (error) {
        console.error("Erro ao buscar unidades:", error);
    }
};



const carregarKits = async () => {
    const params = new URLSearchParams();
    params.append('page', currentPage.value);
    params.append('page_size', pageSize.value);
    if (filters.value.status) params.append('status', filters.value.status);
    if (filters.value.unidade) params.append('unidade', filters.value.unidade);
    if (filters.value.setor) params.append('setor', filters.value.setor);
    if (filters.value.kit_code) params.append('kit_code', filters.value.kit_code);
    if (filters.value.item_name) params.append('item_name', filters.value.item_name);
    if (filters.value.responsavel_interno) params.append('responsible', filters.value.responsavel_interno);
    // Ordenação
    if (sortColumn.value) params.append('sortColumn', sortColumn.value);
    if (sortDirection.value) params.append('sortDirection', sortDirection.value);
    const response = await fetch(`/api/v1/actives/kits/list?${params.toString()}`, { credentials: "include" });
    const data = await response.json();
    kitsPaginados.value = data.items;
    totalPages.value = data.pages;
    totalCount.value = data.count ?? null;
};

const openItensKitModal = (kit) => {
    selectedKitCode.value = kit.kit_code;
    selectedKitItems.value = Array.isArray(kit.equipamentos) ? kit.equipamentos : [];
    isItensKitModalOpen.value = true;
};

const closeItensKitModal = () => {
    isItensKitModalOpen.value = false;
    selectedKitItems.value = [];
    selectedKitCode.value = '';
};

// Debounce para evitar chamadas excessivas
let carregarKitsTimer = null;
const carregarKitsDebounced = () => {
    if (carregarKitsTimer) clearTimeout(carregarKitsTimer);
    carregarKitsTimer = setTimeout(() => {
        carregarKits();
    }, 100);
};

watch([filters, currentPage, pageSize], carregarKitsDebounced, { immediate: true });

const getAvailabilityClass = (availability) => {
    switch (availability) {
        case 'Disponível':
            return 'text-green-600 dark:text-green-400';
        case 'Em uso':
            return 'text-yellow-600 dark:text-yellow-400';
        case 'Indisponível':
            return 'text-red-600 dark:text-red-400';
        default:
            return 'text-gray-600 dark:text-gray-400';
    }
};

function handlePageSizeChange() {
    currentPage.value = 1;
    carregarKits();
}

// Watch para carregar dados quando o modal de filtros for aberto
watch(showFilterModal, async (newValue) => {
    if (newValue) {
        console.log('Carregando dados para o modal de filtros...');
        try {
            await Promise.all([
                fetchUnidades(),
                fetchSetores(),
                fetchResponsibles(),
            ]);
            console.log('Dados carregados com sucesso!');
        } catch (error) {
            console.error('Erro ao carregar dados para o modal:', error);
        }
    }
});
</script>
